import * as z from "zod";
import { dateSchema, REQUIRED_MESSAGE, requiredString } from "components/form/utils";

export const referenceObject = () =>
    z
        .object({ id: requiredString() })
        .or(z.literal(undefined))
        .refine((val) => !!val && !!val.id?.trim(), {
            message: REQUIRED_MESSAGE,
        });

export const casestudySchema = z.object({
    name: requiredString().nonempty("Casestudy cannot be empty"),
    project: requiredString(),
    status: z.string().default("draft"),
    nda_level: z.optional(z.string()).nullable(),
    industry: z.optional(z.string()).nullable(),
    project_name_alias: z.optional(z.string()).nullable(),
    date_started: dateSchema.optional().nullable(),
    tag_line: z.optional(z.string()).nullable(),
    client_requirement: z.optional(z.string()).nullable(),
    solution_overview: z.optional(z.string()).nullable(),
    obstacles: z.optional(z.string()).nullable(),
    achievements: z.optional(z.string()).nullable(),
    team_size: z.number().int().optional().nullable(),
    duration: z.optional(z.string()).nullable(),
    testimonials: z.optional(z.string()).nullable(),
    tools: z.optional(z.string()).nullable(),
    tech_stack: z.optional(z.string()).nullable(),
    outcomes: z.optional(z.string()).nullable(),
    deliverables: z.optional(z.string()).nullable(),
    methodology: z.optional(z.string()).nullable(),
});
